import { Command } from 'commander'

import { BuildSdkCommand } from '@/domains/sdk/build'
import { CreateSdkCommand } from '@/domains/sdk/create'
import { DeleteSdkCommand } from '@/domains/sdk/delete'
import { UpdateSdkCommand } from '@/domains/sdk/update'

import { ListSdkCommand } from './list'

const sdkCommands = [
  ListSdkCommand,
  CreateSdkCommand,
  UpdateSdkCommand,
  DeleteSdkCommand,
  BuildSdkCommand,
]

const sdkDomain = new Command('sdk')

sdkDomain.description('Manage your Scalar SDKs (Enterprise Only)')
sdkCommands.forEach((command) => sdkDomain.addCommand(command()))

export default sdkDomain
